// extracted by mini-css-extract-plugin
export default {"editButton":"PlaygroundJSONViewModeToolbar-module__editButton--WZiYe","iconButton":"PlaygroundJSONViewModeToolbar-module__iconButton--Th6Bp"};